export type Language = 'ko' | 'en' | 'ja' | 'cn';

export interface LanguageConfig {
  code: Language;
  name: string;
  flag: string;
}

export const LANGUAGES: LanguageConfig[] = [
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'cn', name: '中文', flag: '🇨🇳' },
];

export interface Translations {
  predefinedQuestions: string[];
  hoverMessages: (string | null)[];
  menuItems: {
    label: string;
    items: string[];
  }[];
  chatInput: {
    placeholder: string;
    voiceRecording: string;
    voiceLevel: string;
    stopRecording: string;
    listenMessage: string;
    recordingMessage: string;
    sendMessage: string;
    stopSending: string;
    resetChat: string;
    openPredefinedQuestions: string;
  };
  chatWindow: {
    searching: string;
    generating: string;
    playTTS: string;
    stopTTS: string;
    department: string;
    phone: string;
    name: string;
    email: string;
    relatedSite: string;
    feedbackPlaceholder: string;
    submit: string;
    loadingMessages: string[];
    likeAnswer: string;
    dislikeAnswer: string;
    openFeedback: string;
  };
  intro: {
    title: string;
    description: string;
    disclaimer: string;
    dontShowToday: string;
  };
  common: {
    welcomeTagline: string;
    welcomeTitle: string;
    noHoverMessage: string;
    requestData: string;
    confirm: string;
    userGuideTitle: string;
    /** 모바일 영업허가 안내 모달: 입지점검 페이지 이동 버튼 */
    openPermitPage: string;
    openMenu: string;
    closeMenu: string;
    selectLanguage: string;
    enableDarkMode: string;
    disableDarkMode: string;
    closeGuide: string;
  };
  sidebar: {
    mainPhone: string;
    weekdayHours: string;
    weekendHours: string;
    afterHours: string;
  };
  statusBar: {
    sejongWeather: string;
    fineDust: string;
    passportQueue: string;
    people: string;
    todayDate: string;
    currentTemp: string;
    airQuality: string;
    dateFormat: string;
    aqiRatings: {
      good: string;
      normal: string;
      bad: string;
      veryBad: string;
      noData: string;
    };
  };
}
